module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9293bf98ba4486b28fd640db9dd29fba.png";